import React from "react";
import WithDrawalTable from "./withdrawal-table";
import { useWithdrawals } from "../../../../../hooks/use-withdrawal";
import { Withdrawal } from "packages/app/src/types";

interface WithdrawalTableProps {
  withdrawals: Withdrawal[];
  error: Error | null;
  isLoading: boolean;
}

function WithdrawalTableHolder({
  withdrawals,
  isLoading,
  error,
}: WithdrawalTableProps) {
  return (
    <WithDrawalTable
      className="col-span-full"
      withdrawals={withdrawals}
      error={error}
      isLoading={isLoading}
    />
  );
}

export default WithdrawalTableHolder;
